import { useTheme } from "contexts";
import { useLayoutEffect} from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Footer, NavBar, WhatsappButton } from "components";
// import { CALENDLY_URL } from "constants";
// import { PopupModal } from "react-calendly";

export function AppLayout() {
  const { darkMode, setDarkMode } = useTheme();
  const { pathname, hash } = useLocation();
  // const [isOpen, setIsOpen] = useState(false);

  // const pageSetting = {
  //   backgroundColor: "000000",
  //   primaryColor: "22c55e",
  //   textColor: "ffffff",
  //   hideEventTypeDetails: false,
  //   hideLandingPageDetails: false,
  // };

  useLayoutEffect(() => {
    const id = hash.replace("#", "");

    const element = document.getElementById(id);

    if (hash && element) {
      setTimeout(() => {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 150);
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [pathname, hash]);

  return (
    <>
      <NavBar darkMode={darkMode} setDarkMode={setDarkMode} />

      <main className="w-dvh h-dvh overflow-x-hidden">
        <Outlet />
        <Footer />
      </main>

      {/* meeting button */}
      <WhatsappButton/>
    </>
  );
}
